import { usePoints } from '../contexts/PointsContext';
import { useAuth } from '../contexts/AuthContext';

const PointsDisplay: React.FC = () => {
  const { points, targetRef, triggerBump, triggerImpact } = usePoints();
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) return null;

  return (
    <div
      ref={targetRef}
      className={`points-display ${triggerBump ? 'points-bump' : ''} ${triggerImpact ? 'points-impact' : ''}`}
    >
      <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" className="points-icon">
        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
      </svg>
      <span className="points-value">{points}</span>
    </div>
  );
};

export default PointsDisplay;
